/**
 * Legacy re-export shim — `CountrySelect` now lives in
 * `components/shared/CountrySelect.jsx`. This wrapper keeps existing
 * portal call-sites working while adding portal-specific i18n
 * placeholders so we don't break the current Portal Profile UX.
 */
import { useTranslation } from 'react-i18next';
import { CountrySelect as SharedCountrySelect } from '../shared/CountrySelect';

export const CountrySelect = ({ testid = 'country-select', ...rest }) => {
    const { t } = useTranslation('portal');
    return (
        <SharedCountrySelect
            {...rest}
            testid={testid}
            placeholder={t('profile.country_placeholder')}
            searchPlaceholder={t('profile.country_search_placeholder')}
            emptyLabel={t('profile.country_none_found')}
            className="bg-[#FBF8F6] border-[#EFE5E1] hover:bg-[#F5EEEA]"
        />
    );
};

export default CountrySelect;
